import styles from './Spinner.module.scss'

interface SpinnerProps {
  size?: number
  color?: string
  className?: string
}

export const Spinner = ({ size = 40, color = '#ffffff', className = '' }: SpinnerProps) => {
  return (
    <div
      className={`${styles.spinner} ${className}`}
      style={
        {
          '--spinner-size': `${size}px`,
          '--spinner-color': color,
        } as React.CSSProperties
      }
    >
      <div className={styles.spinnerAnimationContainer}>
        <div />
      </div>
    </div>
  )
}
